import { Injectable } from "@angular/core";
import { MatDialog } from '@angular/material';
import { CookieService } from 'ngx-cookie-service';
import { JwtHelperService } from "@auth0/angular-jwt";
import { JwtService } from './../../core/services/jwt.service';
import { CoreCommonService } from 'src/app/core/services/core-common.service';
import { XsAppConfigService } from 'src/app/common/services/xs-app-config.service';
import { XsMessageBoxComponent } from 'src/app/common/widgets/xs-message-box/xs-message-box.component';

@Injectable({
  providedIn: 'root'
})

export class JwtHelperInit {

  constructor(
    private dialog: MatDialog,
    private coreCommonService: CoreCommonService,
    private xsAppConfigService: XsAppConfigService,
    private cookieService: CookieService,
    private jwtService: JwtService,
  ) { }

  myJwtRequest(showBox?: boolean) {
    let myRawToken = this.cookieService.get("token");
    // if (myRawToken) {
    if (this.cookieService.get("token")) {
      this.checkToken(showBox);
    } else {
      let params = {
        "user": "USER_XS",
        "password": "CaOIXqjtXJDbnDrCTZEsswClWuY0PCvK",
      }
      this.jwtService.autenticar(params).then(res => {
        if (res.data.status2) {
          this.cookieService.set('token', res.data.token);
          localStorage.setItem("urlSunat", res.data.urlSunat);
          localStorage.setItem("urlVideo", res.data.urlVideo);
        } else {
          this.mostrarMessageBox2("ERROR", "No se pudo generar el token, por favor actualize la página");
          if (res.data.message2) {
            // this.mostrarMessageBox2("ERROR", res.data.message2);
          } else {
            // this.mostrarMessageBox2("ERROR", "No se pudo realizar la petición para generar el token");
          }
        }
      });
    }
  }

  checkToken(showBox) {
    let myRawToken = this.cookieService.get("token");
    if (myRawToken) {
      const helper = new JwtHelperService();
      const isExpired = helper.isTokenExpired(myRawToken);
      if (isExpired) {
        if (showBox) {
          this.mostrarMessageBoxToken("ATENCIÓN", "Se ha perdido la session");
        } else {
          this.cookieService.deleteAll();
          localStorage.clear();
          // this.onClickCerrarSesion();
          window.location.href = ""+window.location;
        }
      }
    } else {

    }
  }

  mostrarMessageBox2(titulo, mensaje): void {
    const dialogRef = this.dialog.open(XsMessageBoxComponent, {
      width: "400px",
      data: { titulo: titulo, mensaje: mensaje }
    });

    dialogRef.afterClosed().subscribe(resultado => {
    });
  }

  mostrarMessageBoxToken(titulo, mensaje): void {
    const dialogRef = this.dialog.open(XsMessageBoxComponent, {
      width: "400px",
      panelClass: "xs-dlg-base",
      data: { titulo: titulo, mensaje: mensaje }
    });

    dialogRef.afterClosed().subscribe(resultado => {
      this.onClickCerrarSesion();
    });
  }

  onClickCerrarSesion() {
    let plusdSesionToken = this.cookieService.get('plusdSesionToken');
    this.cookieService.deleteAll();
    localStorage.clear();
/*
    if (this.xsAppConfigService.APLICACION_AMBIENTE == 'localhost-nologin') {
      window.location.href = this.coreCommonService.APPLICATION_APP_HOST;
    } else {
      // window.location.href = this.coreCommonService.APPLICATION_APP_HOST + "/logout?tokenSesion=" + plusdSesionToken;
      // window.location.href = this.coreCommonService.APPLICATION_APP_HOST;
      // window.location.href = "https://sistemas.oefa.gob.pe/sice";
      window.location.href = ""+window.location;
    }*/
    window.location.href = ""+window.location;
  }
}

